import { EditButton, DeleteButton, Stack } from "@pankod/refine-mui";

export default {
  title: "Tipologie sistemazioni",
  resource: "accommodation-types",
  canCreate: true,
  columns: [
    { field: "name", headerName: "Nome", flex: 1, minWidth: 300 },
    {
      field: "tot_guests",
      headerName: "Numero Massimo Occupanti",
      flex: 1,
      minWidth: 100,
    },
    {
      headerName: "Azioni",
      field: "actions",
      minWidth: 50,
      renderCell: function render(params) {
        return (
          <Stack direction="row" spacing={1}>
            <EditButton hideText recordItemId={params.row.id} />
            <DeleteButton hideText recordItemId={params.row.id} />
          </Stack>
        );
      },
    },
  ],
};
